'use strict';

angular.module('app')

.directive('mainLoginForm', function () {
    return {
        restrict: 'E',
        scope: {},
        bindToController: {
            onLogin: '&'
        },
        controller: 'LoginFormCtrl',
        controllerAs: '$ctrl',
        templateUrl: 'directives/login/mainLoginForm.html'
    };
});
